module.exports = __webpack_public_path__ + "static/media/styling-product.c6e23844.jpg";